// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserApprove-modulewrapper-j9vtn"};